import React from 'react';
import styled, { css } from 'styled-components';

import { RadioEmptySvg, RadioSelectedSvg } from '../../../assets/icons';
import theme from '../../../assets/theme';

interface RadioProps {
  checked: boolean;
  onCheckChange?: () => void;
}

export const Radio: React.FC<RadioProps> = props => {
  const { checked, onCheckChange } = props;

  return (
    <Wrapper $checked={checked} onClick={onCheckChange}>
      {checked ? <RadioSelectedSvg /> : <RadioEmptySvg />}
    </Wrapper>
  );
};

interface WrapperProps {
  $checked: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  cursor: pointer;
  color: #a5a5a5;
  user-select: none;

  ${({ $checked }) =>
    $checked &&
    css`
      color: ${theme.colors.orange};
    `}
`;
